import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fb9ecec0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-info" }
const _hoisted_2 = { class: "xag-page__footer footer nongfu-button-wrap" }
const _hoisted_3 = { class: "button-wrap" }
const _hoisted_4 = { class: "popup-wrap" }
const _hoisted_5 = { class: "pingan-notice nongfu-button-wrap" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "温馨提示：", -1))
const _hoisted_7 = { class: "content" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-pingan" }, null, -1))

import { Button, Popup } from 'vant'
import { ref, nextTick, computed } from 'vue'
import { getEntryInfo } from '@/utils/index'
import { showConfirmModal } from '@/utils/tools'
import { useRouter, RouterLink, useRoute } from 'vue-router'
import { useActiveHandle } from '@/compositions/insurance/useActiveHandle'
import { usePlatformInfo } from '@/compositions/common'

import appHost, { isApp, isAndrod } from '@/utils/app'
import AppHeader from '@/components/Header.vue'
import JijiaCouponInfo from '../components/jijia-coupon-info.vue'
import JijiaIntroduceContent from '../components/jijia-introduce-content.vue'
import jijiaInsuranceSrc4Tips from '../components/jijia-introduce-src4-tips.vue'


import { defineComponent } from 'vue'
const __default__ = defineComponent({
  name: 'insurance-jijia-insurance-introduce',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const showPopup = ref(false)
const showCouponInfo = ref(false)
const isConfirmUseCoupon = ref(false)
const $router = useRouter()
const $route = useRoute()
const entryData = getEntryInfo()
const isFromActive = entryData.type === 'active'
const sn = entryData.sn
const client = entryData.client
const activeKey = entryData.activeKey
const isFromMiniPay = $route.query.from === 'minipay'
const isFormMessageCenter = $route.query.from === 'messageCenter'
const jumpTag = $route.query.jumpTag as string // 来到该页面时需要直接跳转的标识
const { activeHandle } = useActiveHandle(sn, client, activeKey)
const { isSrc4Device } = usePlatformInfo()
const jijiaSpecialAgreementUrl = computed(() => {
  return `/iframe-wrap?title=保险条款&url=${encodeURIComponent(
    'https://release-platform.xa.com/app_view_page/agreement_doc/bd7b5b24-4504-4a8b-9c35-60d4f74e9672'
  )}`
})

const jijiaNoticeWordUrl = computed(() => {
  return `/iframe-wrap?title=投保须知&url=${encodeURIComponent(
    'https://release-platform.xa.com/app_view_page/agreement_doc/70e99749-d578-4631-b7b2-a850b964194c'
  )}`
})

async function confirmBuyHandle() {
  if (isApp) {
    // 低版本农夫不支持购买
    try {
      const version = await appHost.getNFAppVersion()
      if (version === '') {
        showPopup.value = false
        // 不支持保险购买
        showConfirmModal({
          title: '温馨提示',
          message: isAndrod
            ? '当前极飞农服版本不支持投保，您可以更新到最新版本后再试。'
            : '当前极飞农服版本不支持投保，您可以前往极飞服务小程序投保。',
          confirmButtonText: '知道了',
          className: 'nongfu-dialog-confirm-class nongfu-dialog-confirm-warning-class',
          showCancelButton: false,
        })
        return
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  if (isFromActive) {
    // 激活时需要在当前区域查询设备信息
    showPopup.value = false
    nextTick(() => {
      $router.push({
        name: 'insurance-jijia-insurance-form-page',
        query: {
          sn,
        },
      })
    })
  } else {
    showPopup.value = false
    void $router.push({
      name: 'insurance-jijia-device-select',
    })
  }
}
function onLeftClick() {
  if (isFromActive) {
    // 从激活的时候过来的
    backHandle()
  } else if (isFormMessageCenter && isApp) {
    appHost.goAppBack()
  } else {
    // 常规情况，如果是app就调用sdk返回
    // 嵌入小程序的时候不会经过这里
    //appHost.goAppBack()
    history.go(-1)
  }
}
async function backHandle() {
  if (!isSrc4Device.value) {
    try {
      await showConfirmModal({
        message: '如果后续您需要购买意外机损保险，可前往【我的-服务-保障服务】购买',
        confirmButtonText: '不购买',
        cancelButtonText: '返回购买',
        className: 'repair-dialog',
      })
    } catch (error) {
      return
    }
  }

  activeHandle()
}
function askHandle() {
  let startTime = 1732766400000
  let endTime = 2363918400000
  let needAsk = false // 该版本上线后不需要做升级提示
  let current = Date.now()
  if (current >= startTime && current <= endTime && needAsk) {
    showConfirmModal({
      title: '系统升级中...',
      message: '意外险投保服务升级中，预计 2024 年 11 月 28 日 下午 17 点重新开放！',
      confirmButtonText: '知道了',
      className: 'nongfu-dialog-confirm-class nongfu-dialog-insurance-warning-class',
      showCancelButton: false,
    })
  } else {
    showPopup.value = true
  }
}
function init() {
  let eqSn = sn
  if (!sn && localStorage.getItem('pinanpayCurrentSn')) {
    eqSn = localStorage.getItem('pinanpayCurrentSn')
    localStorage.removeItem('pinanpayCurrentSn')
  }
  localStorage.removeItem('isCancelPayed')
  if (eqSn && isFromMiniPay) {
    let name = 'insurance-jijia-insurance-detail'
    if (jumpTag === 'deviceList') {
      name = 'insurance-jijia-device-select'
    }
    $router.push({
      name,
      query: {
        eq_sn: eqSn,
      },
    })
  } else {
    showCouponInfo.value = true
  }
}
function closeCouponHandle() {
  showCouponInfo.value = false
}
function confirmUseHandle() {
  isConfirmUseCoupon.value = true
  showPopup.value = true
}
init()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, {
      title: "意外机损保险",
      onLeftClick: onLeftClick,
      isReturnLeftEvent: ""
    }),
    _createVNode(jijiaInsuranceSrc4Tips),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(JijiaIntroduceContent)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_unref(isSrc4Device))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(" > "),
              _createVNode(_unref(Button), {
                class: "xa-vant-button src-device-button",
                onClick: onLeftClick
              }, {
                default: _withCtx(() => [
                  _createTextVNode("我知道了")
                ]),
                _: 1
              })
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              isFromActive
                ? (_openBlock(), _createBlock(_unref(Button), {
                    key: 0,
                    class: "cancel-button xa-vant-button",
                    onClick: onLeftClick
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("跳过")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_unref(Button), {
                class: "confirm-button xa-vant-button",
                onClick: askHandle
              }, {
                default: _withCtx(() => [
                  _createTextVNode("询价投保")
                ]),
                _: 1
              })
            ], 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(Popup), {
        show: showPopup.value,
        "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((showPopup).value = $event)),
        position: "bottom",
        class: "custom-popup-border-radius"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createTextVNode(" “意外机损保险”由平安保险销售和承保，点击【询价投保】将前往平安投保系统进行投保和支付。请您在投保前仔细阅读“意外机损保险”的"),
              _createVNode(_unref(RouterLink), {
                to: _unref(jijiaSpecialAgreementUrl),
                class: "link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("保险条款")
                ]),
                _: 1
              }, 8, ["to"]),
              _createTextVNode("、"),
              _createVNode(_unref(RouterLink), {
                to: _unref(jijiaNoticeWordUrl),
                class: "link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("投保须知")
                ]),
                _: 1
              }, 8, ["to"]),
              _createTextVNode("、"),
              _createVNode(_unref(RouterLink), {
                to: "/insurance/jijia-insurance-refund-word?type=2024",
                class: "link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("退保须知")
                ]),
                _: 1
              }),
              _createTextVNode("、"),
              _createVNode(_unref(RouterLink), {
                class: "link",
                to: "/insurance/jijia-client-policy"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("授权条款")
                ]),
                _: 1
              }),
              _createTextVNode("，特别是有关责任免除的相关条款以及其他加粗的部分。您点击【我知道了】视为您已经完整阅读并全面理解上述文件的内容，并同意按照相关内容执行。 ")
            ]),
            _hoisted_8,
            _createVNode(_unref(Button), {
              class: "xa-vant-button confirm-read-btn",
              round: "",
              onClick: confirmBuyHandle
            }, {
              default: _withCtx(() => [
                _createTextVNode("我知道了")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    (showCouponInfo.value)
      ? (_openBlock(), _createBlock(JijiaCouponInfo, {
          key: 0,
          onClose: closeCouponHandle,
          onConfirm: confirmUseHandle,
          sn: _unref(sn)
        }, null, 8, ["sn"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})